// MainPage.jsx
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import NoItemsFound from '../components/NoItemsFound';
import DynamicTable from '../components/DynamicTable';
import { toast } from "react-toastify";

import {
  get_rockfall_by_id,
  get_tags_by_rockfall,
  get_users,
  get_interventions_by_rockfall,
  get_documents_by_rockfall,
  get_installation_documents_by_rockfall,
  create_tag,
  update_tag,
  delete_tag,
  create_intervention,
  update_intervention,
  delete_intervention,
  create_document,
  update_document,
  delete_document,
  create_installationdocument,
  update_installationdocument,
  delete_installationdocument,
} from '../api/api';

import TopBar from '../components/TopBar';
import TitleBackButton from '../components/TitleBackButton';
import Map from '../components/Map';
import { patch_rockfall } from '../api/api.js';
import { Link } from 'react-router-dom';


import {
  getColumnDefs_intervention,
  getNewRowTemplate_intervention,
  getColumnDefs_tag,
  getNewRowTemplate_tag,
  getColumnDefs_document,
  getNewRowTemplate_document,
  getColumnDefs_installationdocument,
  getNewRowTemplate_installationdocument,
} from "../tables_config/tables_config.js";


const ProtectionPage = () => {

  const { item_id } = useParams();
  const [ page, setPage] = useState(1);
  const [ notes, setNotes] = useState(1);
  const [ rockfall, setRockfall] = useState({});
  const [ interventions, setInterventions] = useState({});
  const [ tags, setTags] = useState([]);
  const [ users, setUsers] = useState([]);
  const [ technicalDocuments, setTechnicalDocuments] = useState([]);
  const [ manualDocuments, setManualDocuments] = useState([]);
  const [ evaluationDocuments, setEvaluationDocuments] = useState([]);
  const [ projectDocuments, setProjectDocuments] = useState([]);
  const [ certificateDocuments, setCertificateDocuments] = useState([]);
  const [loading, setLoading] = useState(true);

  const [showMap, setShowMap] = useState(false);
  const [settingCoords, setSettingCoords] = useState(false);
  const [selectedCoords, setSelectedCoords] = useState(null);
  const [isMapClickable, setMapClickable] = useState(false);



  const role = localStorage.getItem('role');
  const canAddNotes = role === 'Intermediate' || role === 'Advanced' || role === 'Admin';



  const setMapClickability = (soWhat)=>{
     console.log("setMapClickability");
     setMapClickable(soWhat);
  }

  const retrieveData = async () => {
    try{
        const get_the_rockfall = async () => {
            const res = await get_rockfall_by_id(item_id);
            const data = res && res.data ? res.data : [];
            setRockfall(data);     // Set state with resolved data
            setNotes(data.notes);
        };
        await get_the_rockfall();


        const get_the_tags = async () => {
            const res = await get_tags_by_rockfall(item_id);
            const data = res && res.data && res.data.results ? res.data.results : [];
            setTags(data);     // Set state with resolved data
        };
        await get_the_tags();


        const get_the_interventions = async () => {
            const res = await get_interventions_by_rockfall(item_id);
            const data = res && res.data && res.data.results ? res.data.results : [];
            setInterventions(data);     // Set state with resolved data
        };
        await get_the_interventions();


        const get_the_users = async () => {
            const res = await get_users();
            const data = res && res.data && res.data.results ? res.data.results : [];
            setUsers(data);     // Set state with resolved data
        };
        await get_the_users();


        const get_the_documents = async () => {
            const res = await get_documents_by_rockfall(item_id);
            const data = res && res.data && res.data.results ? res.data.results : [];

            const res2 = await get_installation_documents_by_rockfall(item_id);
            const data2 = res2 && res2.data && res2.data.results ? res2.data.results : [];

            const technical = data.filter((e)=>e.category==='technical');
            const manual = data.filter((e)=>e.category==='manual');
            const project = data.filter((e)=>e.category==='project');
            const evaluation = data.filter((e)=>e.category==='evaluation');

            const certificate = data2;

            console.log(certificate);

            setTechnicalDocuments(technical);     // Set state with resolved data
            setManualDocuments(manual);     // Set state with resolved data
            setProjectDocuments(project);     // Set state with resolved data
            setCertificateDocuments(certificate);     // Set state with resolved data
            setEvaluationDocuments(evaluation);     // Set state with resolved data

        };
        await get_the_documents();
      }
      catch(error){
            console.error(error);

      }
      finally {
            setLoading(false); // Set loading to false after the fetch is complete
      }
  }




  useEffect( () => {
      retrieveData();
  }, []);


  const saveNotes = async () => {
    var content = document.getElementById("textareaNotes").value;
    var id = rockfall.id;
    var resu = await patch_rockfall(id, {
      notes: content
    });
    var resu;
    if(resu && resu.success){
        toast.success("Note interne salvate correttamente");
    }

  }


  const setThePage = (page_id)=>{
    setPage(page_id);
  }




  const openMapForCoords = (coords) => {
    setShowMap(true);
    setSettingCoords(true);
    setSelectedCoords(coords)
    window.dispatchEvent(new Event("resize"));
    setTimeout(function(){
      document.querySelectorAll(".save-edit-button").forEach((e)=>{e.disabled = true});
    }, 150);
  }

  const coordsCallback = (coords) => {
    setSelectedCoords(coords);
  }

  const closeMapForCoords = () => {
    setShowMap(false);
    setSettingCoords(false);
    window.dispatchEvent(new Event("resize"));
    setTimeout(function(){
      document.querySelectorAll(".save-edit-button").forEach((e)=>{e.disabled = false});
    }, 150);
  }




  const doShowMap = () => {
    setShowMap(true);
    window.dispatchEvent(new Event("resize"));
  }

  const doHideMap = () => {
    setShowMap(false);
    setSettingCoords(false);
  }

  const newRowTemplate_tag = getNewRowTemplate_tag(item_id);
  const newRowTemplate_intervention = getNewRowTemplate_intervention(item_id);
  const newRowTemplate_document = getNewRowTemplate_document(item_id);

  const user_id = localStorage.getItem("user_id");

  return (
    <div>
      <TopBar />

      <div className="content">

            <TitleBackButton
              title={rockfall.name}
            />

        <div className="main-content">

          <div className="detail-container">





          <div className="detail-sidebar">
             <div onClick={()=>setThePage(1)} >

               <div className={"detail-sidebar-entry "+(page===1 ? "active" : "")}>
                Interventi
               </div>

             </div>
             <div onClick={()=>setThePage(2)} >

               <div className={"detail-sidebar-entry "+(page===2 ? "active" : "")}>
                Scheda tecnica
               </div>

             </div>
             <div onClick={()=>setThePage(3)} >

               <div className={"detail-sidebar-entry "+(page===3 ? "active" : "")}>
                Manuale d'installazione
               </div>

             </div>
             <div onClick={()=>setThePage(4)} >

               <div className={"detail-sidebar-entry "+(page===4 ? "active" : "")}>
                Progetto
               </div>

             </div>
             <div onClick={()=>setThePage(5)} >

               <div className={"detail-sidebar-entry "+(page===5 ? "active" : "")}>
                Valutazione stato barriera
               </div>

             </div>
             <div onClick={()=>setThePage(6)} >

               <div className={"detail-sidebar-entry "+(page===6 ? "active" : "")}>
                Certificato corretta posa
               </div>

             </div>
             <div onClick={()=>setThePage(7)} >

               <div className={"detail-sidebar-entry "+(page===7 ? "active" : "")}>
                Tags NFC
               </div>

             </div>
             <div onClick={()=>setThePage(8)} >

               <div className={"detail-sidebar-entry "+(page===8 ? "active" : "")}>
                Note Interne
               </div>

             </div>
          </div>


            <div className="detail-main">

              <div className={page===1 ? "" : "invisible"}>

                {loading ? (
                    <div className="loading-detail">Loading...</div> // Show loading while data is being fetched
                ) : (
                    <DynamicTable
                    items={interventions}
                    rockfall_id={rockfall.id}
                    labelAddNew="intervento"
                    hasMap={false}
                    callbackShowMap={()=>{}}
                    callbackHideMap={()=>{}}
                    createFunction={create_intervention}
                    updateFunction={update_intervention}
                    deleteFunction={delete_intervention}
                    getColumnDefs={getColumnDefs_intervention}
                    newRowTemplate={newRowTemplate_intervention}
                    users={users}
                    user_id={user_id}
                    customAddElelentModal={true}
                    customDetailModal={true}
                    columnKey={'name'}
                    showTransactionModal={true}

                  />
                ) }


              </div>


              <div className={page===2 ? "" : "invisible"}>
                {loading ? (
                    <div className="loading-detail">Loading...</div> // Show loading while data is being fetched
                ) : (
                    <DynamicTable
                    items={technicalDocuments}
                    rockfall_id={rockfall.id}
                    labelAddNew="documento"
                    documentType="technical"
                    hasMap={false}
                    callbackShowMap={()=>{}}
                    callbackHideMap={()=>{}}
                    createFunction={create_document}
                    updateFunction={update_document}
                    deleteFunction={delete_document}
                    getColumnDefs={getColumnDefs_document}
                    newRowTemplate={newRowTemplate_document}
                    columnKey={'name'}
                    showEditButton={false}
                    showDownloadButton={true}
                    showTransactionModal={true}
                    isAddButtonForDocument={true}

                  />
                ) }
              </div>


              <div className={page===3 ? "" : "invisible"}>
                {loading ? (
                    <div className="loading-detail">Loading...</div> // Show loading while data is being fetched
                ) : (
                    <DynamicTable
                    items={manualDocuments}
                    rockfall_id={rockfall.id}
                    labelAddNew="documento"
                    documentType="manual"
                    hasMap={false}
                    callbackShowMap={()=>{}}
                    callbackHideMap={()=>{}}
                    createFunction={create_document}
                    updateFunction={update_document}
                    deleteFunction={delete_document}
                    getColumnDefs={getColumnDefs_document}
                    newRowTemplate={newRowTemplate_document}
                    columnKey={'name'}
                    showEditButton={false}
                    showDownloadButton={true}
                    showTransactionModal={true}
                    isAddButtonForDocument={true}


                  />
                ) }
              </div>


              <div className={page===4 ? "" : "invisible"}>
                {loading ? (
                    <div className="loading-detail">Loading...</div> // Show loading while data is being fetched
                ) : (
                    <DynamicTable
                    items={projectDocuments}
                    rockfall_id={rockfall.id}
                    labelAddNew="documento"
                    documentType="project"
                    hasMap={false}
                    callbackShowMap={()=>{}}
                    callbackHideMap={()=>{}}
                    createFunction={create_document}
                    updateFunction={update_document}
                    deleteFunction={delete_document}
                    getColumnDefs={getColumnDefs_document}
                    newRowTemplate={newRowTemplate_document}
                    columnKey={'name'}
                    showEditButton={false}
                    showDownloadButton={true}
                    showTransactionModal={true}
                    isAddButtonForDocument={true}


                  />
                ) }
              </div>


              <div className={page===5 ? "" : "invisible"}>
                {loading ? (
                    <div className="loading-detail">Loading...</div> // Show loading while data is being fetched
                ) : (
                    <DynamicTable
                    items={evaluationDocuments}
                    rockfall_id={rockfall.id}
                    labelAddNew="documento"
                    documentType="evaluation"
                    hasMap={false}
                    callbackShowMap={()=>{}}
                    callbackHideMap={()=>{}}
                    createFunction={create_document}
                    updateFunction={update_document}
                    deleteFunction={delete_document}
                    getColumnDefs={getColumnDefs_document}
                    newRowTemplate={newRowTemplate_document}
                    columnKey={'name'}
                    showEditButton={false}
                    showDownloadButton={true}
                    showTransactionModal={true}
                    isAddButtonForDocument={true}


                  />
                ) }
              </div>

              <div className={page===6 ? "" : "invisible"}>
                {loading ? (
                    <div className="loading-detail">Loading...</div> // Show loading while data is being fetched
                ) : (
                    <DynamicTable
                    items={certificateDocuments}
                    rockfall_id={rockfall.id}
                    labelAddNew="documento"
                    documentType="certificate"
                    hasMap={false}
                    callbackShowMap={()=>{}}
                    callbackHideMap={()=>{}}
                    createFunction={create_installationdocument}
                    updateFunction={update_installationdocument}
                    deleteFunction={delete_installationdocument}
                    getColumnDefs={getColumnDefs_installationdocument}
                    newRowTemplate={getNewRowTemplate_installationdocument}
                    columnKey={'name'}
                    showEditButton={true}
                    showDownloadButton={true}
                    showTransactionModal={true}
                    isAddButtonForDocument={true}
                    users={users}


                  />
                ) }
              </div>

              <div className={page===7 ? "" : "invisible"}>

                {loading  ? (
                    <div className="loading-detail">Loading...</div> // Show loading while data is being fetched
                ) : (

                <div className="dynamic-table-outer">

                  <div id="the_map_container" style={{display: showMap ? "block" : "none"}}>
                    <Map items={[]} settingCoords={settingCoords} coordsCallback={coordsCallback}  defaultSelectedCoords={selectedCoords} isMapClickable={isMapClickable}/>
                  </div>



                      <DynamicTable
                      items={tags}
                      rockfall_id={rockfall.id}
                      labelAddNew="tag"
                      hasMap={false}
                      callbackShowMap={()=>{}}
                      callbackHideMap={()=>{}}
                      createFunction={create_tag}
                      updateFunction={update_tag}
                      deleteFunction={delete_tag}
                      getColumnDefs={getColumnDefs_tag}
                      newRowTemplate={newRowTemplate_tag}
                      columnKey={'name'}
                      callbackMapClickability={setMapClickability}

                      callbackShowMap={doShowMap}
                      callbackHideMap={doHideMap}
                      openMapForCoords={openMapForCoords}
                      closeMapForCoords={closeMapForCoords}
                      selectedCoords={selectedCoords}
                      showTransactionModal={true}

                    />

                  </div>
                     ) }


              </div>



              <div className={page===8 ? "" : "invisible"}>
                {loading  ? (
                    <div className="loading-detail">Loading...</div> // Show loading while data is being fetched
                ) : (

                <div>
                  <textarea id="textareaNotes" className="internal-notes">{notes}</textarea>
                  { canAddNotes && <button onClick={saveNotes} className="btn internal-notes-btn">Salva note</button> }
                </div>
                )}

              </div>



            </div>


          </div>



        </div>

      </div>
    </div>
  );
};

export default ProtectionPage;
